export default {"src":"/_next/static/media/Dex-Badge-Dark.426c0161.gif","height":625,"width":706};